import { isObject } from "@pineapplelab/util";
import { FBase } from "./FBase";
import { IsNotEmpty } from "@pineapplelab/validators";
import { Language } from "../utils/language";
import { TranslationStatusEnum } from "../enums/translationStatus.enum";

export class LanguageCategory extends FBase {

	@IsNotEmpty({ label: "Language" })
	language: Language = null;
	@IsNotEmpty({ label: "Name" })
	name: string = null;
	description: string = null;
	keywords: string[] = [];
	active: boolean = false;
	isDefault: boolean = false;
	nameLowercase: string = null;
	translationStatus: TranslationStatusEnum = null;
	automaticTranslation: boolean = false;

	__isFullTranslated: boolean = false;
	__selectedCoursesCounter: number = 0;
	__translatedCoursesCounter: number = 0;
	__coursesTranslatingCounter: number = 0;

	constructor(json?: { [key: string]: any }) {
		super();
		if (isObject(json)) {
			this.fromJson(json);
		}
	}
}
export namespace LanguageCategory {

	export const PATH = 'languageCategories';
}
